import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Registrar os componentes necessários do Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ data, includeKeys, nameMap, horizontal, title, titleColor, titleFontSize, labelColor, labelFontSize, height = 200, width = 200 }) => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: []
    });

    const prepareChartData = (data, includeKeys, nameMap) => {
        if (!data || typeof data !== 'object') {
            console.error('Os dados fornecidos estão incorretos.');
            return {
                labels: [],
                datasets: []
            };
        }

        const labels = includeKeys.map(key => nameMap[key] || key);

        const values = includeKeys.map(key => {
            const qtd = data[key]?.qtd;
            return (qtd === null || qtd === undefined) ? 0 : Number(qtd);
        });

        const backgroundColors = [
            'rgba(119, 236, 103, 0.9)',
            'rgba(255, 105, 180, 0.9)',
            'rgba(54, 162, 235, 0.9)',
            'rgba(255, 206, 86, 0.9)',
            'rgba(75, 192, 192, 0.9)',
            'rgba(153, 102, 255, 0.6)',
            'rgba(255, 159, 64, 0.9)',
            'rgba(37, 95, 30, 0.9)',
            'rgba(178, 34, 34, 0.9)',
            'rgba(0, 128, 128, 0.8)',
            'rgba(218, 112, 214, 0.8)'
        ];        

        const barColors = values.map((_, index) => backgroundColors[index % backgroundColors.length]);

        return {
            labels: labels,
            datasets: [
                {
                    label: '',
                    data: values,
                    backgroundColor: barColors,
                    borderColor: 'transparent', // Torna a borda transparente
                    borderWidth: 0 // Remove a borda
                }
            ]
        };
    };

    useEffect(() => {
        if (data) {
            const chart = prepareChartData(data, includeKeys, nameMap);
            setChartData(chart);
        }
    }, [data, includeKeys, nameMap]);

    const options = {
        responsive: true,
        indexAxis: horizontal ? 'y' : 'x',
        plugins: {
            legend: {
                display: true,
                labels: {
                    color: labelColor || '#ccc',
                    font: {
                        size: labelFontSize || 12
                    },
                    boxWidth: 0, // Remove a largura da caixa de cor (botão)
                }
            },
            title: {
                display: true,
                text: title,
                color: titleColor || '#ccc',
                font: {
                    size: titleFontSize || 14
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: labelColor || '#ccc', // Cor das labels do eixo X
                    font: {
                        size: labelFontSize || 12 // Tamanho da fonte das labels do eixo X
                    }
                }
            },
            y: {
                ticks: {
                    color: labelColor || '#ccc', // Cor das labels do eixo Y
                    font: {
                        size: labelFontSize || 12 // Tamanho da fonte das labels do eixo Y
                    }
                }
            }
        }
    };

    return <Bar data={chartData} options={options} height={height} width={width}/>;
};

export default BarChart;